import {
  MarketplaceIntegrationUpsellsDocument,
  MarketplaceIntegrationUpsellsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useGetMarketplaceIntegrationUpsells = (
  variables: MarketplaceIntegrationUpsellsQueryVariables
) => {
  const { loading, data } = useQuery(MarketplaceIntegrationUpsellsDocument, { variables })

  return {
    loading,
    data: data?.marketplace.integrationUpsellsConnection.nodes || [],
  }
}
